import { render } from "./CreateForexAccount.vue?vue&type=template&id=608fdef2"
import script from "./CreateForexAccount.vue?vue&type=script&lang=js"
export * from "./CreateForexAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__